import { Autocomplete, TextField } from '@mui/material'
import React from 'react'

const shippingLineOptions = [
  "Export Air",
  "Export Air 2",
  "Export Sea",
  "Import Air",
  "Import Air 2",
  "Import Sea",
  "Domestic Air",
  "Domestic Air 2",
  "Domestic Land",
  "Domestic Sea",
];

const ShipmentLineField = (props) => {
    const {
        label,
        value,
        onInputChange,
        isError,
    } = props;
  return (
    <Autocomplete
        freeSolo
        disableClearable
        size="small"
        value={value}
        onInputChange={onInputChange}
        options={shippingLineOptions}
        sx={{ mt: 2 }}
        renderInput={(params) => (
            <TextField
                {...params}
                error={isError}
                label={label}
                InputProps={{
                    ...params.InputProps,
                    type: "search",
                }}
            />
        )}
    />
  )
}

export default ShipmentLineField